// extracted by mini-css-extract-plugin
export default {"wrapper":"GoalProgress_wrapper__Z6wey","header":"GoalProgress_header__SHMg6","body":"GoalProgress_body__WQn1b"};